module.exports = __webpack_public_path__ + "static/liva-pastacilik-case-study-3-9c1ee99c227f9484f47ffd51c5c5c160.png";